import { ServiceTimeClass } from '@mews/enums';
import { Service } from '@mews-commander/data-access';
import { getTimeClass } from '@mews-commander/utils';

export const isTimeUnitWithinParentTime = (parentService?: Service, promotedService?: Service) => {
    if (!parentService || !promotedService) return false;
    const parentTimeUnit = getTimeClass(parentService);
    const promotedTimeUnit = getTimeClass(promotedService);

    switch (parentTimeUnit) {
        case ServiceTimeClass.Month:
            return true;
        case ServiceTimeClass.Night:
            if (
                promotedTimeUnit === ServiceTimeClass.Night ||
                promotedTimeUnit === ServiceTimeClass.Day ||
                promotedTimeUnit === ServiceTimeClass.Hour
            ) {
                return true;
            }
            return false;
        case ServiceTimeClass.Day:
            if (promotedTimeUnit === ServiceTimeClass.Day || promotedTimeUnit === ServiceTimeClass.Hour) return true;
            return false;
        case ServiceTimeClass.Hour:
            if (promotedTimeUnit === ServiceTimeClass.Hour) return true;
            return false;
        default:
            return false;
    }
};
